import { useState, useEffect } from 'react';
import { Form, Container, Row, Col, Button } from 'react-bootstrap';
import { IoIosMail, IoIosCall, IoLogoWhatsapp } from 'react-icons/io';
import Captcha from "../../component/Captcha"
import axios from 'axios';
import "../enquiry/ContactBox.css";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from 'aos';

function ContactBox() {
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCaptchaChange = (value) => {
    setCaptchaInput(value);
  };

  const handleCaptchaReset = () => {
    setResetCaptcha(true);
  };

 
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    phone: '',
    state: '',
    option: '',
    message: '',

  });

  const validateForm = async (event) => {
    event.preventDefault();
    if (captchaInput === captchaValue) {
      alert('CAPTCHA Verified!');
      setLoading(true);

      let utm = localStorage.getItem('utm_data') || null;

      let dataVal = {
        ...formValues,
        utm
      }


      try {

        const response = await axios.post('https://gautamsolar.us/submit-contactbox', dataVal);

        // const response = await axios.post('http://localhost:1008/submit-contactbox', dataVal);

        if (response.status === 200) {
          setLoading(false);
          alert('Form submitted successfully!');
          localStorage.removeItem('utm_data');
          setFormValues({
            name: '',
            email: '',
            phone: '',
            state: '',
            option: '',
            message: '',
          })
        } else {
          setFormValues({
            name: '',
            email: '',
            phone: '',
            state: '',
            option: '',
            message: '',
          })
          setLoading(false);
          alert('Error submitting form. Please try again later.');
        }
        handleCaptchaReset();
      } catch (error) {
        setLoading(false);
        console.error('Error:', error);
        alert('Error submitting form. Please try again later.');
      }
    } else {
      setLoading(false);
      alert('CAPTCHA Verification Failed! Please try again.');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

   useEffect(() => {
    AOS.init({});
  }, []);


  return (
    <section id="enquireNowSection" className='border-top border-dark'>
      <Container fluid className="py-5">
        <div className="row py-4" data-aos="fade-down-right">
          <div className="col-lg-9 col-md-8 mx-auto text-center">
            <h2 className=" textRes" style={{ position: 'relative', color: 'black' }}>
              <span style={{
                position: 'absolute',
                top: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
                borderBottom: '2px solid #faab04',
                width: '50px',
              }}></span>
              Enquire <span style={{ color: "#a20000" }}>Now </span>
            </h2>
          </div>
        </div>

        <Row xs={1} xl={1} className="py-4 g-4 container mx-auto">

          <Col xs={12} className="mb-3 mb-md-0">
            <Row className="g-1 mx-auto  d-flex justify-content-center gap-2">
              {[
                {
                  href: "mailto:info@gautamsolar.com",
                  icon: <IoIosMail size={30} />,
                  title: "Email",
                  text: "info@gautamsolar.com",
                },
                {
                  href: "tel:18005320800",
                  icon: <IoIosCall size={30} />,
                  title: "Service Support",
                  text: "1800-532-0800",
                },
                {
                  href: "https://wa.me/919311797248",
                  icon: <IoLogoWhatsapp size={30} />,
                  title: "WhatsApp",
                  text: "+91 9311797248",
                },
              ].map((item, idx) => (
                <Col key={idx} xs={12} md={3}>
                  <a
                    href={item.href}
                    target={item.href.startsWith("https") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      backgroundColor: "#a20000",
                      color: "white",
                      textDecoration: "none",
                      border: "2px solid #a20000",
                      borderRadius: "15px",
                      padding: "5px",
                      textAlign: "center",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <div style={{ marginBottom: "10px", fontSize: '0.4rem' }}>{item.icon}</div>
                    <h5 style={{ marginBottom: "5px", fontSize: '0.9rem' }}>{item.title}</h5>
                    <p style={{ fontSize: "0.9rem", margin: 0 }}>{item.text}</p>
                  </a>
                </Col>
              ))}
            </Row>
          </Col>

          <Col xs={12} className="mx-auto">
            <Container fluid className="px-3 px-md-5">
              <Container
                className="dataform border-top border-red inner"
                style={{
                  backgroundColor: '#f4f4f4',
                  padding: '25px',
                  borderRadius: '20px',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                  maxWidth: '100%',
                }}
              >
                <Form onSubmit={validateForm}>
                  <h2 className='text-center border-bottom' style={{ fontSize: '17px' }}>Submit enquiry</h2>
                  <Row>
                    <Col md={12} className="mb-3">
                      <Form.Group controlId="name">
                        <Form.Label style={{ fontWeight: 'bold' }}>Name:</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter Your Name"
                          value={formValues.name}
                          onChange={handleInputChange}
                          required
                          style={{
                            color: '#a20000',
                            borderColor: '#a20000',
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group controlId="email">
                        <Form.Label style={{ fontWeight: 'bold' }}>Email:</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter Your Email"
                          value={formValues.email}
                          onChange={handleInputChange}
                          required
                          style={{
                            color: '#a20000',
                            borderColor: '#a20000',
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group controlId="phone">
                        <Form.Label style={{ fontWeight: 'bold' }}>Mobile Number:</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          placeholder="Enter Your Phone"
                          value={formValues.phone}
                          onChange={handleInputChange}
                          required
                          style={{
                            color: '#a20000',
                            borderColor: '#a20000',
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group controlId="state">
                        <Form.Label style={{ fontWeight: 'bold' }}>State:</Form.Label>
                        <Form.Control
                          type="text"
                          name="state"
                          placeholder="Enter Your State"
                          value={formValues.state}
                          onChange={handleInputChange}
                          required
                          style={{
                            color: '#a20000',
                            borderColor: '#a20000',
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group controlId="options">
                        <Form.Label style={{ fontWeight: 'bold' }}>Willing to invest:</Form.Label>
                        <Form.Control
                          as="select"
                          name="option"
                          value={formValues.option}
                          onChange={handleInputChange}
                          required
                          style={{
                            borderColor: '#a20000',
                          }}
                        >
                          <option value="" disabled>Select your investment</option>
                          <option>More than Rs. 10 Crores</option>
                          <option>Rs. 1 Crores to 10 Crores</option>
                          <option>Rs. 10 Lacs to 1 Crores</option>
                          <option>Rs 1 Lacs to 10 Lacs</option>
                          <option>Less than Rs. 1 Lac</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>

                    <Col md={12} className="mb-3">
                      <Form.Group controlId="message">
                        <Form.Label style={{ fontWeight: 'bold' }}>Remarks:</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="message"
                          placeholder="Your message"
                          value={formValues.message}
                          onChange={handleInputChange}
                          style={{
                            color: '#a20000',
                            borderColor: '#a20000',
                            resize: 'none'
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={12} className="mb-3 text-center">
                      <Captcha
                        captchaValue={captchaValue}
                        setCaptchaValue={setCaptchaValue}
                        handleCaptchaChange={handleCaptchaChange}
                        resetCaptcha={resetCaptcha}
                        setResetCaptcha={setResetCaptcha}
                      />

                      <Button
                        style={{
                          backgroundColor: '#a20000',
                          border: 'none',
                          padding: '10px 30px',
                          marginTop: '15px',
                          fontWeight: 'bold',
                        }}
                        type="submit"
                        disabled={loading}
                      >
                        {loading ?
                          <div className="spinner-border text-white" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          : 'Send Message'
                        }
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ContactBox;
